/**
 * 게시글 본문의 인라인 이미지와 API 이미지 슬롯 간의 변환을 담당하는 유틸리티
 */

export interface ExtractedSlots {
  update_message: string;
  image2?: string;
  image3?: string;
  image4?: string;
  image5?: string;
}

/**
 * HTML 본문에서 인라인 이미지(figure[data-embed="story-image"])를 추출하여 
 * 슬롯 플레이스홀더([[IMG_SLOT_N]])로 치환하고 base64 데이터를 반환합니다.
 */
export const extractImageSlots = (html: string): ExtractedSlots => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const figures = doc.querySelectorAll('figure[data-embed="story-image"]');
  
  const result: ExtractedSlots = {
    update_message: html,
  };

  figures.forEach((fig, index) => {
    const slotNum = index + 2; // image2부터 시작
    if (slotNum > 5) return; // 최대 5개 슬롯 제한

    const img = fig.querySelector('img');
    if (img) {
      const src = img.getAttribute('src') || '';
      
      // 만약 base64 데이터라면 API로 보낼 수 있게 추출
      if (src.startsWith('data:image')) {
        const base64Data = src.split(',')[1];
        (result as any)[`image${slotNum}`] = base64Data;
      }
      
      // 본문 내의 이미지는 플레이스홀더로 치환
      const placeholder = document.createTextNode(`[[IMG_SLOT_${slotNum}]]`);
      fig.parentNode?.replaceChild(placeholder, fig);
    }
  });

  result.update_message = doc.body.innerHTML;
  return result;
};

/**
 * 본문의 슬롯 플레이스홀더([[IMG_SLOT_N]])를 실제 이미지 태그로 복원합니다.
 * 에디터에서 수정할 때 사용하거나 뷰어에서 렌더링할 때 사용합니다.
 */
export const restoreImageSlots = (html: string, postData: any): string => {
  if (!html) return '';
  
  let restoredHtml = html;
  
  for (let i = 2; i <= 5; i++) {
    const placeholder = `[[IMG_SLOT_${i}]]`;
    const url = postData[`image${i}_url` as keyof typeof postData];
    
    if (restoredHtml.includes(placeholder)) {
      if (url) {
        // 에디터용 figure 구조로 복원
        const replacement = `<figure data-embed="story-image" contenteditable="false"><img src="${url}" data-embed="image"></figure>`;
        restoredHtml = restoredHtml.replace(placeholder, replacement);
      } else {
        // 이미지가 없으면 플레이스홀더 제거
        restoredHtml = restoredHtml.replace(placeholder, '');
      }
    }
  }
  
  return restoredHtml;
};
